import React from 'react';
import {isAndroid, isIOS} from 'react-device-detect';
import {Linking, Platform, Pressable, View} from 'react-native';

import GoogleWalletImage from '../../../images/brand/svg/wallet/enAU_add_to_google_wallet_wallet-button.svg';
import AppleWalletImage from '../../../images/brand/svg/wallet/US-UK_Add_to_Apple_Wallet_RGB_101421.svg';

type AddToWalletProps = {
  walletUrl: string;
  pending?: boolean;
};

// react native web opens in new tab by default but we
// should open in current tab.
// react native web openURL implementation accepts 2nd arg
const openURL =
  Platform.OS === 'web'
    ? (Linking.openURL as (url: string, target?: '_blank' | '_self') => Promise<void>)
    : Linking.openURL;

export default function AddToWallet({walletUrl, pending}: AddToWalletProps) {
  return (
    <View style={{alignItems: 'center'}} testID="wallet-container">
      <Pressable
        onPress={() => {
          if (walletUrl !== '') {
            openURL(walletUrl, '_self');
          }
        }}
        accessibilityRole="button">
        {isAndroid ? (
          <GoogleWalletImage height={48} testID="GoogleWalletImage" />
        ) : isIOS ? (
          <AppleWalletImage height={48} width={151} testID="AppleWalletImage" />
        ) : null}
      </Pressable>
      {!!pending && (
        <View
          testID="pending-overlay"
          style={{
            backgroundColor: 'white',
            opacity: 0.5,
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          }}
        />
      )}
    </View>
  );
}
